import React from 'react';
import DiagramUtils from '../../utils/DiagramUtils';
import Model from "./CountDownModel";
import moment from "moment"
import AutoRefreshDiagramUI from '../AutoRefreshDiagramUI';
// window.moment = moment
import _ from "lodash"
const regex = /(\[[^\[]*\])|(\\)?(DD?t|DD?|HH?t|HH?|mm?t|mm?|ss?t|ss?|.)/g

export default class UI extends AutoRefreshDiagramUI {

    state = {};

    constructor(props, context) {
        super(props, context);
    }
    renderTime() {
        let format = this.props.model.countDownFormat
        if (format === "custom") format = this.props.model.countDownFormatCustom
        let deadline = this.props.model.deadline
        let now = new Date();
        let duration = deadline - now;
        let prefix = duration > 0 ? "" : "-"
        duration = Math.abs(duration)

        let map = {}
        let d = duration / 86400000
        map.D = Math.floor(d)
        map.Dt = map.D
        map.DD = map.D > 99 ? map.D : _.padStart(map.D, 3, '0')
        map.DDt = map.DD

        let h = d * 24
        map.H = Math.floor(h - map.Dt * 24)
        map.Ht = Math.floor(h)
        map.HH = map.H > 9 ? map.H : _.padStart(map.H, 2, '0')
        map.HHt = map.Ht > 9 ? map.Ht : _.padStart(map.Ht, 2, '0')

        let m = h * 60
        map.m = Math.floor(m - map.Ht * 60)
        map.mt = Math.floor(m)
        map.mm = map.m > 9 ? map.m : _.padStart(map.m, 2, '0')
        map.mmt = map.mt > 9 ? map.mt : _.padStart(map.mt, 2, '0')

        let s = m * 60
        map.s = Math.floor(s - map.mt * 60)
        map.st = Math.floor(s)
        map.ss = map.s > 9 ? map.s : _.padStart(map.s, 2, '0')
        map.sst = map.st > 9 ? map.st : _.padStart(map.st, 2, '0')

        return prefix + UI.match(format, map)
    }

    render() {
        return (
            <div className={"diagram-ui " + (this.props.className || "")} style={this.props.model.toStyle()}  >
                {this.renderTime()}
            </div>
        );
    }
    static match(format, map) {
        let matchs = format.match(regex)
        for (let index = 0; index < matchs.length; index++) {
            let key = matchs[index];
            let value = map[key]
            if (value) {
                matchs[index] = value
            } else {
                matchs[index] = this.replace(key)
            }
        }
        return matchs.join('')
    }
    static replace(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }
}

const type = new Model().getType();
DiagramUtils.register(type, {
    model: Model,
    name: type,
    alias: "倒计时",
    catalog: "其他",
    svg: "#anticon-app_automation_timer",
    uiGetter: (model) => <UI model={model} />
});